import Constants from 'expo-constants'
import { Dimensions, StatusBar } from 'react-native'
import { platformSelect } from '../../utils/platformUtils'
import { AppBarTheme } from '../../../themeConstants'

const styles = {
    // Styles for the StatusBar
    containerStatusBar: {
        flex: 1,
    },
    gradientStatusBar: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
    },
    // Styles for the AppBar
    appBarParent: {
        paddingTop: platformSelect({
            ios: Constants.statusBarHeight,
            default: 0,
        }),
    },
    appBarParentBenefits: {
        paddingTop: platformSelect({
            ios: Constants.statusBarHeight,
            android: Constants.statusBarHeight,
            default: 0,
        }),
    },
    appBar: {
        marginTop: 0,
        paddingHorizontal: 8,
        paddingVertical: 10,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    appBarAvatar: {
        width: AppBarTheme.navImageWidth,
        height: AppBarTheme.navImageHeight,
        transform: AppBarTheme.navImageTransform,
        //imageAlign: 'center',
    },
    appBarStatusOff: {
        width: 20,
        height: 20,
        backgroundColor: 'red',
        borderRadius: 10,
        marginLeft: 10,
    },

    appBarNotifications: {
        width: 25,
        height: 25,
        borderRadius: 15,
        marginRight: 10,
    },
    appBarLeft: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    arrow: {
        marginHorizontal: 5,
    },
    appBarRight: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
    },
    appBarIcons: {
        marginLeft: 5,
        paddingHorizontal: 5,
    },
    wifi: {
        height: 15,
        width: 15,
        marginLeft: 10,
    },
    bell: {
        width: 23,
        height: 23,
    },
}

export default styles
